var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header",class:_vm.className},[_c('b-container',{staticClass:"header-content",attrs:{"fluid":"xl"}},[(!_vm.isMobile)?_c('NavBarPC'):_c('NavBarMobile')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }